<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import {
  getToken,
  removeToken,
  removeUuid,
  removeschoolCode,
  removeroleId,
} from "@/utils/auth";
export default {
  name: "app",
  data() {
    return {
      version: "", //build版本号
    };
  },
  mounted() {
    //关闭浏览器
    // window.addEventListener("beforeunload", () => {
    //   removeToken();
    //   removeUuid();
    //   removeschoolCode();
    //   removeroleId();
    // });
  },

  computed: {},
  created() {
    if (process.env.MY_VERSION) {
      this.version = process.env.MY_VERSION;
      console.log("当前版本", this.version);
    }
  },
};
</script>




// WEBPACK FOOTER //
// src/App.vue